import classnames from 'classnames'
import React, { ReactNode } from 'react'

interface IAccountProps {
  className?: string
  children: ReactNode
}

export const PureAccount = (props: IAccountProps) => {
  const className = classnames('def-lst__acc', props.className)

  return <span className={className}>{props.children}</span>
}
